import React from 'react';
// Material UI
import { withStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
// styles
import styles from './styles';

const SkeletonTableCOlumn = ({ classes, ...props }) => {
    return <Skeleton variant="rect" height={20} className={classes.root} />;
};

export default withStyles(styles)(SkeletonTableCOlumn);
